import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import MaterialDivider from './MaterialDivider';
import UltracentrifugationForm from './UltracentrifugationForm';
import DialysisForm from './DialysisForm';
import SterilefiltrationForm from './SterilefiltrationForm';

const PurificationMethodForm = ({ index, data }) => {
  const { 
    handleDelete, handlePurificationChange, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Purification'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Box mt={1}>
        <FormControl error={`method-${data?.index}` in formErrors}>
          <RadioGroup
            row
            aria-labelledby="purification_method"
            name={`purification_method-${data?.index}`}
            value={data?.method}
            onChange={e => handlePurificationChange(data?.index, e.target.value)}
          >
            <FormControlLabel value="Ultracentrifugation" control={<Radio />} label="Ultracentrifugation" />
            <FormControlLabel value="Dialysis" control={<Radio />} label="Dialysis" />
            <FormControlLabel value="Sterile filtration" control={<Radio />} label="Sterile filtration" />
          </RadioGroup>
          <FormHelperText>{formErrors[`method-${data?.index}`]}</FormHelperText>
        </FormControl>

        {data?.method === 'Ultracentrifugation' && <UltracentrifugationForm data={data} />}
        {data?.method === 'Dialysis' && <DialysisForm data={data} />}
        {data?.method === 'Sterile filtration' && <SterilefiltrationForm data={data} />}
      </Box>
    </Box>
  );
};

PurificationMethodForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default PurificationMethodForm;